import { Image } from 'lucide-react';
import { FilterStringConfig } from 'v5/patterns/filters/FilterWidget.types';

export function createProductionIconFilterConfig(): FilterStringConfig {
  return {
    label: 'Icon',
    icon: <Image />,
    type: 'string',
    createDefaultValue: () => ({ operator: 'contains', value: '' })
  };
}
